import type { ProductAvailabilityType } from '@/lib/hooks/services/useGetSkuAvailability'
import { useTranslate } from '@/components/Helpers/Translate'

type Props = {
  skuAvailability: ProductAvailabilityType
  isAddingItemToCart: boolean
}

export const SelectedActiveSubscriptionBackOrderAlert = ({
  skuAvailability,
  isAddingItemToCart,
}: Props) => {
  const { translate } = useTranslate()
  if (skuAvailability !== 'back_order') return null
  if (isAddingItemToCart) return null

  return (
    <div
      className=" p-3 text-[#D03C3C]"
      dangerouslySetInnerHTML={{
        __html: translate('back_order_item_notice'),
      }}
    ></div>
  )
}
